/** Photo thumbnail strip — shared by the tech card and the admin Job Detail sheet.
 *  Full-size opens in a new tab (the API sets inline disposition + private caching). */
export function PhotoThumbs({ keys }: { keys: string[] }) {
  if (!keys.length) return null;
  return (
    <div class="mt-2 flex gap-2 overflow-x-auto">
      {keys.map((k) => (
        <a
          key={k}
          href={`/api/photos?key=${encodeURIComponent(k)}`}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={`/api/photos?key=${encodeURIComponent(k)}`}
            alt="Job photo"
            width={56}
            height={56}
            loading="lazy"
            class="h-14 w-14 rounded-lg border border-slate-200 object-cover"
          />
        </a>
      ))}
    </div>
  );
}
